import React from 'react';
// @ts-expect-error - TS7016 - Could not find a declaration file for module 'shared/components/page_header'. 'app/webpack/javascripts/shared/components/page_header.js' implicitly has an 'any' type.
import PageHeader from 'shared/components/page_header';
import { HeaderDescription, Link, ContentWrapper } from './components';
import BreadCrumbs from '@grnhse/seedling/lib/azalea/components/breadcrumbs';
import t from 'shared/utils/translation';
import styled, { useTheme } from 'styled-components';
import { Body } from '@grnhse/seedling/lib/birch/typography';

type HeaderProps = {
  privacyAndComplianceSettingsPath: string;
  learnMoreUrl: string;
};

function Header(props: HeaderProps) {
  const theme = useTheme();
  // @ts-expect-error - TS2339 - Property 'name' does not exist on type 'DefaultTheme'.
  const isBirch = theme?.name === 'birch';
  const Description = isBirch ? Body : HeaderDescription;

  return (
    <div>
      <div>
        <GDPRBreadCrumbs
          links={[
            {
              label: t('privacy_and_compliance.title'),
              url: props.privacyAndComplianceSettingsPath,
            },
            {
              label: t('gdpr.gdpr_header_component_header'),
            },
          ]}
        />
        <GDPRHeader>{t('gdpr.gdpr_header_component_header')}</GDPRHeader>
        {/* @ts-expect-error - TS2769 - No overload matches this call. */}
        <ContentWrapper redesign={isBirch}>
          <Description>
            {t('gdpr.gdpr_header_component_description')}
            <Link href="https://www.greenhouse.io/gdpr" target="_blank">
              {t('gdpr.gdpr_header_component_link')}
            </Link>
          </Description>
        </ContentWrapper>
      </div>
    </div>
  );
}

export const GDPRHeader = styled(PageHeader)`
  margin-bottom: 8px;
`;

const GDPRBreadCrumbs = styled(BreadCrumbs)`
  padding-bottom: 6px;
`;

export default Header;
